/*
 * File: Fairness360.jsx
 * Project: Machine Trust Platform
 * File Created: Friday, 20th August 2021 11:51:46 am
 * Author: Archit Bhatia (archit.bhatia@nuenergy.ai)
 * -----
 * Last Modified: Friday, 10th September 2021 9:14:36 am
 * Modified By: Tarek Sanger (tarek@nuenergy.ai)
 * -----
 * Copyright 2017 - 2021 NuEnergy.ai, NuEnergy.ai
 */
import React from 'react';
import ConfigureMessage from '../../components/container/ConfigureMessage';
<ConfigureMessage />;

const Aequitas = () => {
  return <ConfigureMessage />;
};

export default Aequitas;
